import { useMutation } from 'convex/react'; // CROSS_IMPORT_JUSTIFIED: convex/react is the official client-side React bindings package, not a server module
import { api } from '@convex/_generated/api';
import type { Id } from '@convex/_generated/dataModel';

export function useUpdateRequestProvider(): (
  requestId: Id<'leadInsuranceRequests'>,
  providerId: Id<'insuranceProviders'> | null
) => Promise<void> {
  const mutate = useMutation(api.leadInsuranceRequests.mutations.setProvider);
  return async (requestId, providerId) => {
    await mutate({ requestId, providerId });
  };
}
